"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/config.js"));

var _reactRouter = require("react-router");

var _const = require("./const");

var _Kesi2Home = _interopRequireDefault(require("../Kesi2Home"));

var _QDConnect = _interopRequireDefault(require("../QDConnect"));

var _DrupalKesi2RootFlippingTiles = _interopRequireDefault(require("../DrupalKesi2RootFlippingTiles"));

var _SettingsCordova = _interopRequireDefault(require("../../SettingsCordova/SettingsCordova"));

var i = 0;
var FEATURE_ROUTES = [/*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(_const.FEATURE_NAME, "-").concat(i++),
  path: "kesi2home",
  component: _Kesi2Home["default"]
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(_const.FEATURE_NAME, "-").concat(i++),
  path: "kesi2(/:contentPath)",
  component: _DrupalKesi2RootFlippingTiles["default"]
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(_const.FEATURE_NAME, "-").concat(i++),
  path: "tourismushub(/:contentPath)",
  component: _DrupalKesi2RootFlippingTiles["default"]
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(_const.FEATURE_NAME, "-").concat(i++),
  path: "kesi2settings",
  component: _SettingsCordova["default"]
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(_const.FEATURE_NAME, "-").concat(i++),
  path: "qdconnect",
  component: _QDConnect["default"]
})];
var _default = {
  FEATURE_ROUTES: FEATURE_ROUTES
};
exports["default"] = _default;